import { useEffect, useState } from 'react';

export default function App() {
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({ status: 'loading', products: [] });

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const timeout = setTimeout(() => controller.abort(), 10000);

    async function loadProducts() {
      try {
        const response = await fetch('/api/products', {
          signal: controller.signal,
          cache: 'no-store',
        });
        if (!response.ok) throw new Error('Request failed');
        const data = await response.json();
        if (
          !Array.isArray(data.products) ||
          data.products.length > 100 ||
          !data.products.every(
            (value) => Number.isInteger(value) && value >= -2147483648 && value <= 2147483647,
          )
        ) {
          throw new Error('Invalid response');
        }
        if (active) {
          setResult({
            status: data.products.length ? 'success' : 'empty',
            products: data.products,
          });
        }
      } catch {
        if (active) setResult({ status: 'error', products: [] });
      } finally {
        clearTimeout(timeout);
      }
    }

    loadProducts();
    return () => {
      active = false;
      clearTimeout(timeout);
      controller.abort();
    };
  }, [attempt]);

  function reload() {
    setResult({ status: 'loading', products: [] });
    setAttempt((current) => current + 1);
  }

  return (
    <main>
      <h1>Hello World</h1>
      <div className="result" aria-live="polite" aria-busy={result.status === 'loading'}>
        {result.status === 'loading' && <p role="status">正在加载…</p>}
        {result.status === 'success' && <p>Products: {result.products.join(', ')}</p>}
        {result.status === 'empty' && <p>暂无数据。</p>}
        {result.status === 'error' && <p role="alert">加载失败，请稍后重试。</p>}
      </div>
      <button type="button" onClick={reload} disabled={result.status === 'loading'}>
        {result.status === 'error' ? '重试' : '重新加载'}
      </button>
    </main>
  );
}
